/*
	Requires a child component to send and event up
	See mobile menu as a basic example
	Wll then have to add the listener in

	On rendering, also need to include the drawerHeader snippet which will then allow the drawer to close

*/

import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { DrawerHeader } from './DrawerHeader';
import { DrawerFooter } from './DrawerFooter';
import { SideCart } from '../SideCart/SideCart';
// import { MobileMenu } from '../MobileMenu/MobileMenu';
import { ProductButtonOption } from '../Product/ProductButtonOption';
import { BodyOverlay } from '../BodyOverlay/BodyOverlay';

@Component
export class DrawerContainer extends ThemeComponent {
    @Ref drawerHeader!: DrawerHeader;
    @Ref({ required: false }) drawerFooter!: DrawerFooter;
    @Ref({ required: false }) drawerContent!: SideCart | ProductButtonOption;
    @Ref({ required: false }) option1!: SideCart | ProductButtonOption;
    @Prop() useOverlay!: boolean;
    private focusableElements =
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    private previousFocus: Element = document.body;
    private bodyOverlay: BodyOverlay|null = null;

    /** Initialise component */
    init() {
        this.bodyOverlay = document.querySelector('.body-overlay');

        if (this.bodyOverlay) {
            this.$subscribe(this.bodyOverlay.onCloseChange, () => {
                this.toggleClose();
            });
        }

        this.setAttribute('aria-hidden', 'true');

        if (this.drawerHeader) {
            this.$subscribe(this.drawerHeader.onCloseChange, this.toggleClose.bind(this));
        }
        if (!this.drawerFooter) {
            return;
        }
        this.$subscribe(this.drawerFooter.onCloseChange, this.toggleClose.bind(this));

        if (this.drawerContent) {
            this.$subscribe(this.drawerContent.onOpenChange, this.toggleOpen.bind(this));

        }
        if (this.option1) {
            this.$subscribe(this.option1.onOpenChange, this.toggleOpen.bind(this));
        }

        document.addEventListener('overlay-clicked', () => this.toggleClose());
    }

    /** Handle focus lock */
    handleFocusLock() {
        const firstFocusableElement = this.querySelectorAll(this.focusableElements)[0] as HTMLElement;
        const focusableContent = this.querySelectorAll(this.focusableElements);
        const lastFocusableElement = focusableContent[focusableContent.length - 1] as HTMLElement;
        this.$log.info(JSON.stringify(lastFocusableElement.classList));

        document.addEventListener('keydown', (e) => {
            const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) { // if shift key pressed for shift + tab combination
                if (document.activeElement === firstFocusableElement) {
                    e.preventDefault();
                    lastFocusableElement.focus(); // add focus for the last focusable element
                }
            } else { // if tab key is pressed
                if (firstFocusableElement === lastFocusableElement) {
                    e.preventDefault();
                    firstFocusableElement.focus();
                }

                if (document.activeElement === lastFocusableElement) {
                    e.preventDefault();
                    firstFocusableElement.focus();
                }
            }
        });

        setTimeout(() => {
            firstFocusableElement.focus();
        }, 300);
    }

    /** Toggle drawer open */
    toggleOpen() {
        if (document.activeElement) {
            this.previousFocus = document.activeElement;
        }
        document.body.classList.add('drawer-open');
        if (this.useOverlay) {
            this.bodyOverlay?.openOverlay();
        }
        this.setAttribute('open', 'true');
        this.setAttribute('aria-hidden', 'false');
        this.handleFocusLock();
    }

    /** Toggle drawer close */
    toggleClose() {
        const previous = this.previousFocus as HTMLElement;

        document.body.classList.remove('no-scroll');
        setTimeout(() => {
            document.body.classList.remove('drawer-open');
        }, 400);
        if (this.useOverlay) {
            this.bodyOverlay?.closeOverlay();
        }
        this.removeAttribute('open');
        this.setAttribute('aria-hidden', 'true');
        previous.focus();
    }
}
